<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout
      row
      wrap
      justify-center
      align-center
    >
      <v-flex
        xs12
        md12
      >
        <v-card>
          <v-toolbar
            dense
            flat
            light
            color="grey lighten-5"
          >
            <v-toolbar-title>Numaralara SMS Gönder</v-toolbar-title>
          </v-toolbar>
          <v-alert style="overflow-x: auto;margin: 0 10px;" type="warning">
            <span>
              HATIRLATMA!
              <br>
              Ticari SMS içeriklerinde;
              firmalar için Mersis No, şahıs işletmelerinde  ise;
              Ad Soyad ve TC.Kimlik Numarası, telefon veya email gibi iletişim bilgisinin
              RET Hizmeti ile birlikte bulunması önem teşkil etmektedir.
            </span>
          </v-alert>
          <v-card-text>

          <v-layout wrap>
            <v-flex>
                <!-- GRUPLAR -->
              <selective-group-list
                :items="data.groups"
                search-label="Grupları filtrelemek için arama yapınız."
                @rip:child="childChange"
              >
              </selective-group-list>
              <!-- <root-list
                  :items="data.groups"
                  search-label="Grupları filtrelemek için arama yapınız."
                  @rip:change="loadGroups"
                  @rip:child="childChange"
                  search
                  smart
                >
                </root-list> -->
            </v-flex>

            <v-divider vertical> </v-divider>

            <v-flex
              md4
              id="scroll-target"
            >
              <div class="d-flex flex-column justify-space-between h-100">
                <!-- KİŞİLER -->
                <selective-contact-list
                  v-model="groupContacts"
                  v-scroll:#scroll-target="onScroll"
                  class="tt"
                  :header="groupContactName"
                  :filter="tree"
                  :loading="contactsLoading"
                  :pagination="pagination"
                  @con:select-all="selectAll"
                  @con:change="addSelectedContact"
                  @con:filter-change="lastTree"
                  @searching="contactSearch"
                  @con:length="contactsPageFinished"
                  item-value="name"
                  no-value-text="Seçili bir grup veya grubun rehberi yok"
                >
                </selective-contact-list>
                <v-spacer></v-spacer>
                <v-pagination
                  circle
                  v-model="pagination.current"
                  :page="pagination.current"
                  :length="pagination.total"
                  :total-visible="6"
                  @input="onSearching ? contactsSearchPagination(pagination.current) : contactsPagination(pagination.current)"
                >
                </v-pagination>
              </div>
            </v-flex>

            <v-divider vertical> </v-divider>

            <v-flex
              xs12
              md4
              class="tt d-flex flex-column"
            >
              <!-- SEÇİLİ KİŞİLER -->
              <v-subheader class="my-4">MESAJ GÖNDERİLECEK KİŞİLER</v-subheader>
              <div class="pa-4 flex-1" style="max-height: 42rem; overflow-y: auto">
                <div
                  v-if="tree.length === 0"
                  class="font-weight-light grey--text pa-4 text-center"
                >
                  Seçili rehber kaydı yok
                </div>

                <v-scroll-x-transition
                  group
                  hide-on-leave
                >
                  <v-chip
                    v-for="(selection, i) in tree"
                    :key="i"
                    color="grey"
                    close
                    @click:close="removeSelected(selection)"
                    dark
                    medium
                    class="ma-1"
                  >
                    <v-icon
                      left
                      small
                      color="light-blue lighten-4"
                    >done_all</v-icon>
                    {{ selection.name }} {{ selection.surname }}
                  </v-chip>
                </v-scroll-x-transition>

              </div>
              <div class="mx-4 mt-4">
                <v-btn
                  block
                  color="primary"
                  @click.stop="createMessage"
                >
                  Mesajı Oluştur
                  <v-icon
                    right
                    dark
                  >
                    mdi-send
                  </v-icon>
                </v-btn>
              </div>

            </v-flex>
          </v-layout>

          <!-- <v-layout
            row
            justify-center
            align-center
          >
            <v-flex
              xs10
              d-flex
            >
              <v-btn
                block
                color="primary"
                @click.stop="createMessage"
              >
                Mesajı Oluştur
                <v-icon
                  right
                  dark
                >
                  mdi-send
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout> -->
          </v-card-text>

        </v-card>
      </v-flex>
    </v-layout>

    <prepare
      v-show="smsPreparing"
      :confirmation="confirmation"
      :valid="smsPreparing"
      :data="prepareData"
      @on:close="smsPreparing = !smsPreparing"
      @on:send="smsSending"
      @on:preview="smsPreview"
      @update:confirmation="(valid) => (confirmation.valid = valid)"
    >
    </prepare>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import SelectiveGroupList from '../../../Components/SelectiveList/SelectiveGroupList.vue';
// import RootList from '../../../Components/SelectiveList/RootList.vue';
import SelectiveContactList from '../../../Components/SelectiveList/SelectiveContactList.vue';
import Prepare from '../../../Components/SelectiveMessage/Prepare.vue';

export default {
  name: 'Selective',
  components: {
    Prepare,
    SelectiveContactList,
    SelectiveGroupList,
    // RootList,
  },
  data: () => ({
    contactsLoading: false,
    topReach: 0,
    scroll: '',
    smsPreparing: false,
    groupContacts: [],
    groupContactName: '',
    pagination: {
      current: 0,
      total: 1,
    },
    data: {},
    lastTree: {},
    prepareData: {
      senders: [],
    },
    tree: [],
    currentParameter: {},
    confirmation: {
      valid: false,
      context: {
        examples: [],
      },
    },
    onSearching:false,
    keyword:""
  }),
  created() {
    this.loadGroups();
  },
  methods: {
    ...mapActions({ send: 'sendBackend', sendAsync: 'asyncSender' }),
    selectAll() {
      this.groupContacts = [];
      this.loadGroupContacts(this.currentParameter);
    },
    loadGroups() {
      this.send({ route: 'sms/selective' }).then((res) => {
        this.data = res.data.data;
      });
    },
    setInitial() {
      this.groupContacts = [];
      this.pagination = {
        current: 0,
        total: 1,
      };
    },
    childChange(val) {
      this.setInitial();
      this.onSearching = false;
      this.loadGroupContacts(val);
    },
    loadGroupContacts(val) {
      if (this.pagination.total >= this.pagination.current) {
        this.contactsLoading = true;
        this.currentParameter = val;
        this.send({
          route: `details/group?page=${this.pagination.current}`,
          data: { id: [val.id] },
        })
          .then(async (res) => {
            this.groupContacts = [...this.groupContacts, ...res.data.data.contacts.data];
            this.groupContactName = `${val.name} (${res.data.data.contacts.total})`;

            this.pagination.current = await res.data.data.contacts.current_page;
            this.pagination.total = res.data.data.contacts.last_page;
            this.pagination.group_id = val.id;
            this.pagination.group_name = val.name;

            /*
             Burası aktif olursa kaydı olmayan bir grup geldiğinde ard arda 100-200 istek atıyor
             if (this.groupContacts.length <= 10) {
              this.loadGroupContacts(val);
            }
            */
          })
          .finally(() => {
            this.contactsLoading = false;
          });
      }
    },
    addSelectedContact(val) {
      if (this.tree.filter(t => t.id === val.id).length === 0) {
        this.tree.push(val);
      } else if (this.tree.length === 0) {
        this.tree.push(val);
      }
    },
    removeSelected(val) {
      this.tree = this.tree.filter(con => con !== val);
      this.$trigger('con:filter-change', val);
    },
    contactsPagination(val) {
      const route = `details/group?page=${val}`;
      const data = { id: [this.pagination.group_id] };
      this.send({ route, data }).then((res) => {
        this.groupContacts = res.data.data.contacts.data;
        this.groupContactName = `${res.data.data.name} (${res.data.data.contacts.total})`;

        this.pagination.current = res.data.data.contacts.current_page;
        this.pagination.total = res.data.data.contacts.last_page;
        this.pagination.group_id = res.data.data.id;
      });
    },
    contactsSearchPagination(val) {
      const route = `search/contact?page=${val}`;
      const data = { group_id: this.pagination.group_id,value:this.keyword };

      this.sendAsync({ route, data }).then((res) => {
        this.groupContacts = res.data.data;
        this.pagination.current = res.data.current_page;
        this.pagination.total = res.data.last_page;
      });
    },
    createMessage() {
      if (this.tree.length > 0) {
        this.smsPreparing = !this.smsPreparing;

        this.send({ route: 'sms/selective' }).then((res) => {
          this.prepareData = res.data.data;
          this.$trigger('setInitials');
        });
      }
    },
    smsSending(sendData) {
      const data = { ...sendData };
      data.id = this.tree.map(tree => tree.id);

      this.send({
        route: 'sms/selective/send',
        data,
      });
    },
    smsPreview(sendData) {
      if (this.confirmation.valid) {
        this.confirmation.valid = false;
        this.$trigger('setPluginDialog');
      }
      const data = { ...sendData };
      data.id = this.tree.map(tree => tree.id);

      this.send({ route: 'sms/selective/send/preview', data }).then((res) => {
        this.confirmation.context = res.data.data;
      });
    },
    contactSearch(keyword) {
      this.keyword = keyword;
      this.onSearching = true;
      if (keyword === '' || keyword === null) {
        this.contactsPagination(this.pagination.current);
      } else {
        const data = {
          value: keyword,
          group_id: this.currentParameter.id,
        };
        this.sendAsync({ route: 'search/contact', data }).then((res) => {
          this.groupContacts = res.data.data;
          this.pagination.current = res.data.current_page;
          this.pagination.total = res.data.last_page;
        });
      }
    },
    contactsPageFinished(len) {
      if (len === 0) {
        this.pagination.current += 1;
        this.contactsPagination(this.pagination.current);
      }
    },
    // eslint-disable-next-line spaced-comment
    onScroll(/*e*/) {
      /*
      const y = e.target.scrollTop;
      const max = e.target.scrollHeight - e.target.offsetHeight - 1;

      if (max < y) {
        this.pagination.current = this.pagination.current + 1;
        this.loadGroupContacts(this.currentParameter);
      }
       */
    },
  },
};
</script>

<style scoped>
/* @media screen and (max-width: 600px) {
  .tt {
    overflow-y: scroll;
    max-height: 250px;
  }
}

@media screen and (min-width: 600px) {
  .tt {
    overflow-y: scroll;
    max-height: 500px;
  }
} */
</style>
